import React, { useState } from 'react'
import MediaSectionStyle, { MediaTwoSectionStyle } from './MediaSectionStyle'
import vidimg from '../img/vidimg.png'
import showcase from '../img/showcase.jpeg'
import compnyimg from '../img/compnyimg.jpeg'
import companyimg2 from '../img/companyimg2.jpeg'
import companyimg3 from '../img/companyimg3.jpeg'
import companyimg4 from '../img/companyimg4.jpeg'

const MediaSection = () => {
  // https://youtu.be/60x4XymEOpo?si=Yi9dWbCOIwsGGXf0
   const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
 const images = [
    { src: showcase, alt: 'Showcase' },
    { src: compnyimg, alt: 'Company' },
    { src: companyimg2, alt: 'Company 2' },
    { src: companyimg3, alt: 'Company 3' },
    { src: companyimg4, alt: 'Company 4' },
    { src: vidimg, alt: 'Video thumbnail' }
  ];
   const youtubeVideos = [
    '60x4XymEOpo', // Replace with your video IDs
    'hzmjiRhEOO0', // Replace with your video IDs
    '8I6hZG33GmQ'  // Replace with your video IDs
  ];
   // Function to get YouTube embed URL with parameters to hide suggestions
  const getYouTubeEmbedUrl = (videoId) => {
    return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&showinfo=0`;
  };

 const openImage = (index) => {
    setCurrentIndex(index);
    setSelectedImage(images[index].src);
    document.body.style.overflow = 'hidden';
  };

  const closeImage = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const nextImage = (e) => {
    e.stopPropagation();
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex].src);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex].src);
  };

  React.useEffect(() => {
    const handleKeyPress = (e) => {
      if (!selectedImage) return;
      if (e.key === 'Escape') closeImage();
      if (e.key === 'ArrowRight') nextImage(e);
      if (e.key === 'ArrowLeft') prevImage(e);
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [selectedImage, currentIndex]);
    return (
     <MediaTwoSectionStyle>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="secondary-heading">
              <h2>Media</h2>
              <p className="section-subtitle">Explore our videos and gallery</p>
            </div>

            {/* YouTube Videos Section */}
            <div className="youtube-section">
              <h3 className="subsection-title">Featured Videos</h3>
              <div className="video-grid">
                {youtubeVideos.map((videoId, index) => (
                  <div key={index} className="video-wrapper">
                    <iframe
                      src={getYouTubeEmbedUrl(videoId)}
                      title={`YouTube video ${index + 1}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Images Section */}
            <div className="images-section">
              <h3 className="subsection-title">Gallery</h3>
              <div className="image-grid">
                <figure className="pic-hover hover-scale mb30">
                  <span className="bg-overlay"></span>
                  <img src={showcase} alt="Showcase" />
                </figure>
                <figure className="pic-hover hover-scale mb30">
                  <span className="bg-overlay"></span>
                  <img src={compnyimg} alt="Company" />
                </figure>
                <figure className="pic-hover hover-scale mb30">
                  <span className="bg-overlay"></span>
                  <img src={companyimg2} alt="Company 2" />
                </figure>
                <figure className="pic-hover hover-scale mb30">
                  <span className="bg-overlay"></span>
                  <img src={companyimg3} alt="Company 3" />
                </figure>
                <figure className="pic-hover hover-scale mb30">
                  <span className="bg-overlay"></span>
                  <img src={companyimg4} alt="Company 4" />
                </figure>
                <figure className="pic-hover hover-scale mb30">
                  <span className="bg-overlay"></span>
                  <img src={vidimg} alt="Video thumbnail" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MediaTwoSectionStyle>
  
    );
}

export default MediaSection
